// Local
// export const API_URL = "http://localhost:5000/api/v1";

// Prod
// export const API_URL = "https://api.prod.arja.szvp2024.com/api/v1/";

// Dev
export const API_URL = " https://api.spinner.ewp.szvp2024.com/api/v1";
